module.exports = __webpack_public_path__ + "img/36.f838b96e.jpg";